<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>रिफंड </h2>
                </div>
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='31'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="32">

                    <label for="" class="mt-3">रिफंड भुगतान प्रक्रिया का एक हिस्सा है
                        जो आपको उस ग्राहक को धनराशि (पैसा) वापस करने की अनुमति देता है जिसने पहले
                        खरीदारी की है। वे ग्राहकों की संतुष्टि बनाए रखने और आपके व्यवसाय के वित्तीय
                        लेनदेन के प्रबंधन के लिए आवश्यक हैं। रिफंड एक ऐसी प्रक्रिया है जिसके माध्यम
                        से आप किसी उत्पाद या सेवा के लिए ग्राहक के भुगतान का एक हिस्सा या संपूर्ण
                        भुगतान वापस कर देते हैं। यह विभिन्न कारणों से हो सकता है, जैसे उत्पाद
                        रिटर्न, रद्दीकरण, या ग्राहक शिकायतों का समाधान।
                    </label>
                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="33">

                    <h2>
                        रिफंड के प्रमुख तत्व:
                    </h2>

                    <ul>
                        <li class="mt-3"><b>पहल: </b>&nbsp;जब कोई ग्राहक किसी उत्पाद को वापस करने का
                            अनुरोध करता है, ऑर्डर रद्द कर देता है, या किसी ऐसी समस्या का सामना करता
                            है जिसके लिए रिफंड की आवश्यकता होती है, तो व्यापारी द्वारा रिफंड शुरू
                            किया जाता है। </li>

                        <li class="mt-3"><b>प्रसंस्करण: </b>&nbsp;एक बार धनवापसी का अनुरोध करने के
                            बाद, आप पे जी के माध्यम से धनवापसी प्रक्रिया शुरू कर सकते हैं। पे जी रिफंड
                            की गई राशि को ग्राहक के खाते में वापस स्थानांतरित करने के लिए संबंधित
                            वित्तीय संस्थानों से संचार करता है। </li>

                        <li class="mt-3"><b>समयरेखा: </b>&nbsp;रिफंड संसाधित करने की समयसीमा ग्राहक
                            द्वारा उपयोग की जाने वाली भुगतान पद्धति और शामिल बैंकों की नीतियों के
                            आधार पर भिन्न हो सकती है। उदाहरण के लिए, क्रेडिट कार्ड रिफंड को ग्राहक
                            के खाते में प्रतिबिंबित होने में कुछ कार्यदिवस लग सकते हैं। </li>

                        <li class="mt-3"><b>संचार: </b>&nbsp;ग्राहक को रिफंड प्रक्रिया के बारे में
                            सूचित रखना महत्वपूर्ण है। उन्हें धनवापसी शुरू होने की पुष्टि और एक
                            अनुमानित समय-सीमा प्रदान करें जब वे धन वापस मिलने की उम्मीद कर सकते हैं।
                        </li>
                    </ul>

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="34">
                    <h2>रिफंड का महत्व: </h2>

                    <ul>
                        <li class="mt-3"><b>ग्राहक संतुष्टि: </b>&nbsp;ग्राहकों की संतुष्टि बनाए
                            रखने में रिफंड महत्वपूर्ण भूमिका निभाता है। यदि कोई ग्राहक अपनी खरीदारी
                            से खुश नहीं है, तो परेशानी मुक्त रिफंड की पेशकश करने में सक्षम होना
                            सकारात्मक प्रभाव छोड़ सकता है।
                        </li>

                        <li class="mt-3"><b>विश्वास निर्माण: </b>&nbsp;विश्वसनीय लेनदेन की तरह,
                            परेशानी मुक्त रिफंड आपके और आपके ग्राहकों के बीच विश्वास बनाने में
                            योगदान देता है। यह भरोसा दोबारा व्यापार और सकारात्मक बातचीत का कारण बन
                            सकता है। </li>

                        <li class="mt-3"><b>संघर्ष समाधान: </b>&nbsp; रिफंड मुद्दों को हल करने में
                            भी काम आता है। यदि किसी ग्राहक को कोई क्षतिग्रस्त या गलत उत्पाद प्राप्त
                            होता है, तो शीघ्र धनवापसी की पेशकश संभावित नकारात्मक अनुभव को सकारात्मक
                            में बदल सकती है।
                        </li>
                    </ul>
                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="35">
                    <h2>पे जी रिफंड का उपयोग करना: </h2>


                    <label for="" class="mt-3">पे जी के साथ, आप मर्चेंट पोर्टल के
                        माध्यम से रिफंड को कुशलतापूर्वक प्रबंधित कर सकते हैं। रिफंड शुरू करें, उनकी
                        प्रगति को ट्रैक करें और रिफंड की स्थिति के बारे में ग्राहकों से सीधे संवाद
                        करें। </label>
                    <label for="" class="mt-3">संक्षेप में, रिफंड ग्राहक-व्यावसायिक
                        संबंध का एक अभिन्न अंग है। रिफंड को समझने और प्रभावी ढंग से प्रबंधित करके,
                        आप ग्राहकों की संतुष्टि बढ़ा सकते हैं, विश्वास बना सकते हैं और अपने ग्राहकों
                        के साथ सहज बातचीत सुनिश्चित कर सकते हैं। पे जी रिफंड प्रक्रिया को यथासंभव सहज
                        बनाने में आपकी सहायता के लिए यहां है।
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">

                    <h5>
                        विषयसूची:
                    </h5>
                </div>

                <!-- <div class="col-md-12 mt-2">
                    <a href="#31"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10"><span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                Introduction to Refunds </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-2">
                    <a href="#32">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">
                                    रिफंड का परिचय </span>
                            </div>

                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#33">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    रिफंड के तत्व
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#34">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">
                                    रिफंड का महत्व </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#35">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" [ngClass]="{'color':colors=='5'}" (click)="color('5')">
                                    पे जी रिफंड </span>
                            </div>
                        </div>
                    </a>
                </div>


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
               
                <a [routerLink]="['/transaction']">  <button class="btn btn-color" (click)="menues('Transactions')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Transactions
                </button></a>
            </div>
            <div class="col-md-4    ">
             
                <a [routerLink]="['/disputes']"> <button class="btn btn-color" (click)="menues('Disputes')" >डिस्प्यूट्स
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>